var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcThumbsupBlue = function SvgIcThumbsupBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "-1.9 -2.5 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0950BD",
    stroke: "#16181C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.2 5.2H2A1.5 1.5 0 0 0 .5 6.7v10.296a1.5 1.5 0 0 0 1.5 1.5h1.2a1.5 1.5 0 0 0 1.5-1.5V6.7a1.5 1.5 0 0 0-1.5-1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#67AEFF",
    stroke: "#16181C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.296 7.526v7.97a3 3 0 0 0 3 3h6.873a2.5 2.5 0 0 0 2.412-1.842l1.957-7.188a2.5 2.5 0 0 0-2.411-3.157h-4.095V2.5a2 2 0 0 0-2-2h-.037a2 2 0 0 0-1.67.9z"
  })));
};
export default SvgIcThumbsupBlue;